module.exports = __webpack_public_path__ + "static/media/mypath.6e3a2b5b.png";